<template>
    <modal :show.sync=show modalClasses="medium-sized-modal" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500">Assign Lead To</h3>
        <ValidationObserver v-slot="{ invalid }" ref="observer">
            <b-form @submit.prevent="submit">
                <b-row>
                    <!-- FIELD LEADS -->
                    <!-- <b-col cols="12" md="12">
                        <b-form-group label="Lead Name:">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'newCallLead'"
                            >
                            <el-select v-model="new_call.leads_id" filterable placeholder="Select" :disabled="isLeadDataExists">
                                <el-option
                                v-for="lead in leadName"
                                :key="lead.lead_id"
                                :label="lead.name"
                                :value="lead.lead_id"
                                >
                                </el-option>
                            </el-select>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col> -->

                    <!-- FIELD LEAD NAME -->
                    <b-col cols="12">
                        <b-form-group label="Bulk Leads" v-if="bulk_assign" hidden>
                        </b-form-group>
                        <b-form-group label="Lead:" v-else>
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'assignToLead'"
                            >
                                <b-form-input
                                v-model="assign_to.lead_name"
                                required
                                placeholder="Subject"
                                readonly
                                ></b-form-input>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>

                    <!-- FIELD USER (Assigned To) -->
                    <b-col cols="12" md="12">
                        <b-form-group label="Assign To:">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'assignToMember'"
                            >
                            <el-select v-model="assign_to.user_id" filterable placeholder="Assign To" @change="changeUser($event)">
                                <el-option
                                v-for="member in agentsList"
                                :key="member.id"
                                :label="member.name"
                                :value="member.id"
                                >
                                </el-option>
                            </el-select>
                            <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                        <b-button variant="primary" type="submit" class="w-100" :disabled="invalid">Assign</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </ValidationObserver>

    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option } from 'element-ui'
import { 
  notifyFunctionMixin,
  helperFunctionMixin,
  axios,
  services,
  getHeader
} from '@/assets/js/httpImports.js'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import '@/assets/js/formValidations.js'
import { mapState, mapActions } from 'pinia'
import { useAuthStore } from '@/stores/authStore'
import { useMessagingStore } from '@/stores/messagingStore'

export default {
    props:{
        assign_lead: Boolean,
        lead_data: Array,
    },
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin
    ],
    components: {
        Modal,
        ValidationObserver,
        ValidationProvider,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    async created() {
        this.agentsList = await this.getUserList()
        // this.getHubTeamMember()
        this.$watch(
            () => this.lead_data,
            (newVal) => {
                // MEANS SINGLE ASSIGN
                if (newVal.assign_type == 1) 
                {
                    this.bulk_assign = false
                    newVal[0] ? this.assign_to.lead_id = newVal[0].lead_id : ""
                    newVal[0] ? this.assign_to.lead_name = newVal[0].name : ""
                    
                    this.assign_to.user_id = newVal[0] ? (newVal[0].assign_to ? Number(newVal[0].assign_to) : "") : "";
                    this.assign_to.hub_name = newVal[0] ? (newVal[0].hub ? newVal[0].hub.hub_name : "") : "";
                    // this.assign_to.hub_team = newVal[0] ? (newVal[0].assign_to.team ? newVal[0].assign_to.team.hub_team_name : "") : "";

                    //all_hub_team_member being fetched based on the role current user
                    // this.hub_team_member_list = this.all_hub_team_member.filter((hub) => {
                    //     // MEANS THIS LEAD NO HUB ID
                    //     if(!this.lead_data[0].hub)
                    //     {
                    //         return ""
                    //     }
                    //     else
                    //     {
                    //         return hub.hub_team.hub_id == this.lead_data[0].hub.hub_id
                    //     }
                    // });

                    // this.hub_team_member_list = this.all_hub_team_member

                }
                else
                {
                    this.bulk_assign = true
                    if(newVal[0])
                    {
                        // this.assign_to.user_id = newVal[0][0].assign_to.member.id
                        this.assign_to.user_id = ""
                        this.bulk_ids = [];
                        newVal[0].forEach(element => {
                            this.bulk_ids.push(element.lead_id)
                            this.assign_to.lead_id = this.bulk_ids
                        });
                    }
                    // this.hub_team_member_list = this.all_hub_team_member.filter((hub) => {
                    //     if(!this.lead_data[0][0].hub){
                    //         return this.all_hub_team_member
                    //     }else{
                    //         return hub.hub_team.hub_id == this.lead_data[0][0].hub.hub_id
                    //     }
                    // });
                }
            },
            { immediate: true }
        )
    },
    computed: {
        show: {
            get() {
                return this.assign_lead;
            },
            set(newVal) {
                this.$emit('update:assign_lead', newVal);
            },
        },
        ...mapState(useAuthStore,['auth_user']),
    },
    data() {
        return {
            assign_to: {
                lead_id: '',
                lead_name: '',
                user_id: '',
                hub_name: '',
                hub_team: '',
            },
            hub_team_member_list: [],
            all_hub_team_member: [],
            user_data: {},
            bulk_assign: true,
            bulk_ids: [],
            userList: [],
        }
    },
    methods:{
				...mapActions(useMessagingStore, ['getProfileBundleKey','checkUserGroup']),
        submit(){

            if(this.lead_data.assign_type == 1){
                const formData = {
                    assign_to: this.assign_to.user_id,
                    lead_id: this.assign_to.lead_id,
                }

                axios.put(services.lead + 'assign_to/'+this.assign_to.user_id,formData, { headers: getHeader() })
                .then(res => {
										this.autoSetChatGroup();
                    this.notifySuccess('<b>Status: '+res.data.message+'</b> - Successfully Updated.')
                    this.$emit('closeAssignToModal')
                    this.$emit('getLeads')
                    delete this.lead_data.assign_type;
                })
                .catch(e => {
                    this.errorFunction(e)
                })
            }
            else
            {
                const formData = {
                    ids: this.bulk_ids,
                    assign_to: this.assign_to.user_id
                }

                axios.put(services.lead + 'assign_to/'+this.assign_to.user_id,formData, { headers: getHeader() })
                .then(res => {
										this.autoSetChatGroup();
                    this.notifySuccess('<b>Status: '+res.data.message+'</b> - Successfully Updated.')
                    this.$emit('closeAssignToModal')
                    this.$emit('getLeads')
                    delete this.lead_data.assign_type;
                })
                .catch(e => {
                    this.errorFunction(e)
                })
            }

        },
        getHubTeamMember(){
            // console.log(this.user_data);
            axios.get(services.hub + 'get_hub_team_member_list', {headers: getHeader()})
            .then(res => {
                this.hub_team_member_list = res.data.data
            })
            .catch(e => {
                // commented this cause to prevent error shown if they dont have hub
                // this.errorFunction(e)
            })
        },
        changeUser(user_id){
            let filteredData = this.all_hub_team_member.filter(element => element.team_member.id == user_id).map(element =>element.hub_team.hub_team_name)
            this.assign_to.hub_team = filteredData[0]
        },
				autoSetChatGroup(){
					let user_id = this.assign_to.user_id;
					let type = 'lead';
					let channelIds = _gAuth.activeCorpSettings('lead_reassign_only_channel_ids',[])
					const leads = (this.lead_data.assign_type == 1) ? [this.lead_data[0]] : this.lead_data[0];
					
					if(!_gHlp.isEmpty(leads)){
						leads.forEach(lead => {
							
							let bundle_key = this.getProfileBundleKey('lead', lead);
							let channel_id = _gHlp.getValue(lead, 'channel_id');
							let msg_txt = _gHlp.getValue(lead, 'message');
							let is_add_all_group = !((msg_txt == 'lead-slack') || channelIds.includes(channel_id))
							
							this.checkUserGroup(user_id, bundle_key, type, is_add_all_group);
						});
					}
				}
    }
}
</script>